import React from 'react';
import {
    Box,
    Typography,
    Button,
    Paper,
    Alert
} from '@mui/material';
import { RefreshCw, AlertTriangle } from 'react-feather';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Error caught by boundary:", error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    handleReset = () => {
        // Clear localStorage entries that might be corrupted
        if (this.state.error && this.state.error.message &&
            this.state.error.message.includes("JSON")) {
            // If it's a JSON parse error, there might be corruption in localStorage
            // Only clear specific keys to avoid wiping user session data
            localStorage.removeItem("tenant_tickets");
            localStorage.removeItem("tenant_details");
            console.log("Cleared potentially corrupted localStorage data");
        }

        // Reload the page
        window.location.reload();
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <Box sx={{ p: 3 }}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 4,
                            borderRadius: '10px',
                            border: '1px solid rgba(0, 0, 0, 0.08)',
                            textAlign: 'center'
                        }}
                    >
                        <AlertTriangle size={64} color="#F59E0B" />

                        <Typography variant="h5" sx={{ mt: 3, fontWeight: 600 }}>
                            Something went wrong
                        </Typography>

                        <Typography variant="body1" color="textSecondary" sx={{ mt: 2, mb: 3 }}>
                            We encountered an error while trying to display this page.
                        </Typography>

                        {this.state.error && (
                            <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
                                <Typography variant="body2" component="div">
                                    <strong>Error:</strong> {this.state.error.toString()}
                                </Typography>
                            </Alert>
                        )}

                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<RefreshCw size={16} />}
                            onClick={this.handleReset}
                            sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                                boxShadow: 'none'
                            }}
                        >
                            Refresh Page
                        </Button>
                    </Paper>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;